import { useEffect, useRef } from 'react';

// Clé Google Maps (Places autocomplete). Restreinte par référent côté console Google.
const GOOGLE_MAPS_API_KEY = 'AIzaSyBkah70PBzRjRKFC0sx0TmtLzNwJ9eRXTo';

// Charge le SDK Google Places une seule fois et branche l'autocomplete sur l'input.
export const useGooglePlacesAutocomplete = (
  inputRef: React.RefObject<HTMLInputElement>,
  onSelect: (address: string) => void,
) => {
  const autocompleteRef = useRef<any>(null);
  const onSelectRef = useRef(onSelect);
  useEffect(() => {
    onSelectRef.current = onSelect;
  }, [onSelect]);

  useEffect(() => {
    if (!inputRef.current || autocompleteRef.current) return;
    const loadScript = () => {
      if (document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]')) {
        return (window as any).google?.maps?.places
          ? Promise.resolve()
          : new Promise<void>((r) => {
              const t = setInterval(() => {
                if ((window as any).google?.maps?.places) {
                  clearInterval(t);
                  r();
                }
              }, 100);
            });
      }
      return new Promise<void>((resolve) => {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`;
        script.async = true;
        script.onload = () => resolve();
        document.head.appendChild(script);
      });
    };
    loadScript().then(() => {
      if (!inputRef.current || !(window as any).google?.maps?.places) return;
      autocompleteRef.current = new (window as any).google.maps.places.Autocomplete(inputRef.current, {
        types: ['address'],
        componentRestrictions: { country: 'fr' },
        fields: ['formatted_address'],
      });
      autocompleteRef.current.addListener('place_changed', () => {
        const place = autocompleteRef.current.getPlace();
        if (place?.formatted_address) onSelectRef.current(place.formatted_address);
      });
    });
  }, [inputRef]);
};
